/**
 * Estado do assistente de IA como a tela de Atendimento o enxerga. Regra única de "quem atende":
 * a coluna `channel_conversations.mode` vale `ai` por padrão em TODA conversa, então ela sozinha
 * não diz que a IA está respondendo. A IA só responde sozinha com o assistente ligado em piloto;
 * desligado, em sombra ou em sugestão o atendimento é 100% humano.
 */
import type { AiStatus } from "../../api/ai-types.js";

/** `off` = desligada (ou servidor de IA indisponível). */
export type AiLiveMode = "off" | AiStatus["mode"];

export function aiLiveMode(status: AiStatus | undefined): AiLiveMode {
  return status?.enabled ? status.mode : "off";
}

/** `aiMode` indefinido = comportamento legado (a view não sabe do assistente): vale o modo da conversa. */
export function aiAnswers(aiMode: AiLiveMode | undefined, conversation: { mode: string }): boolean {
  if (aiMode === undefined) return conversation.mode === "ai";
  return aiMode === "pilot" && conversation.mode === "ai";
}
